module.exports = __webpack_public_path__ + "static/media/capsule_machine_ori_2.c3a82042.png";